import {useContext} from 'react'

import SearchContext from './index'

const useSearchContext = () => {
  const search = useContext(SearchContext)
  if (!search) {
    throw new Error('Missing SearchContextProvider in its parent.')
  }
  return search
}

export default useSearchContext
